import { createContext, useContext, useEffect, useId } from 'react';

export interface WalletWidgetContainerContextValue {
  publishedText?: string;
  publishText: (publisherId: string, text: string | undefined) => void;
}

export const WalletWidgetContainerContext = createContext<WalletWidgetContainerContextValue | undefined>(undefined);

/**
 * Hook for child components to publish resolved badge text to the parent
 * WalletWidgetContainer. The container displays the last published value in
 * the header badge. Pass `undefined` to clear the published text.
 */
export const useWalletWidgetBadgePublisher = (text: string | undefined): void => {
  const ctx = useContext(WalletWidgetContainerContext);
  const publisherId = useId();

  useEffect(() => {
    if (!ctx) return undefined;
    ctx.publishText(publisherId, text);
    return () => ctx.publishText(publisherId, undefined);
  }, [ctx, publisherId, text]);
};
